module.exports = __webpack_public_path__ + "img/216793682.0852c787.jpg";